
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/custom-domains-settings",
      function () {
        return require("private-next-pages/profile/custom-domains-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/custom-domains-settings"])
      });
    }
  